import TestFilterTabs from '../generic/TestFilterTabs';
import QsTypeBreakupSummary from './QsTypeBreakupSummary';
import QsTypeBreakupTestwise from './QsTypeBreakupTestwise';
import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPackQsTypeBreakup, setPage } from '../../../../../apps/frontend/src/redux/slices/packSlice';
import PackPagination from '../generic/PackPagination';
import { useNavigate } from 'react-router-dom';
import PackButton from '../generic/PackButton';

const QsTypeBreakup = ({ pack, onResetFilters }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Scroll states
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isDescriptionVisible, setIsDescriptionVisible] = useState(true);
  const scrollContainerRef = useRef(null);

  const packId = localStorage.getItem('selectedPackId');

  const {
    qsTypeBreakup: { data, loading },
    filters,
  } = useSelector((state) => state.pack);

  // Fetch when page OR testFilter changes
  useEffect(() => {
    if (!packId) return;
    dispatch(
      fetchPackQsTypeBreakup({
        packId,
        page: filters?.page || 1,
        testFilter: filters?.testFilter,
      }),
    );
  }, [dispatch, packId, filters?.page, filters?.testFilter]);

  // Hide-on-scroll logic
  useEffect(() => {
    const handleScroll = () => {
      if (!scrollContainerRef.current) return;

      const currentScrollY = scrollContainerRef.current.scrollTop;
      const isTabletOrBelow = window.innerWidth < 1024; // lg breakpoint

      if (!isTabletOrBelow) {
        if (currentScrollY <= 0) {
          if (!isDescriptionVisible) setIsDescriptionVisible(true);
        } else if (currentScrollY > 70 && isDescriptionVisible) {
          setIsDescriptionVisible(false);
        } else if (currentScrollY < 30 && !isDescriptionVisible) {
          setIsDescriptionVisible(true);
        }
        setIsHeaderVisible(true);
        return;
      }

      if (currentScrollY < lastScrollY) {
        setIsHeaderVisible(true);
      } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsHeaderVisible(false);
      }

      setLastScrollY(currentScrollY);
    };

    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll, { passive: true });
      return () => scrollContainer.removeEventListener('scroll', handleScroll);
    }
  }, [lastScrollY, isDescriptionVisible]);

  const totalPages = data?.totalPagesAvailable || 1;
  const activePage = filters?.page || 1;

  return (
    <div className="w-full max-w-4xl mx-auto flex flex-col h-screen overflow-y-auto" ref={scrollContainerRef}>
      {/* Header */}
      <div
        className={`z-10 q3-glass rounded transition-transform duration-300 ease-in-out lg:translate-y-0 ${
          isHeaderVisible ? 'translate-y-0' : '-translate-y-full'
        }`}
      >
        <div className="p-6 pb-4">
          {/* Mobile Back Button */}
          <PackButton navigateTo="/v2/home" />

          <div className="mb-6">
            <h1 className="text-3xl font-bold text-[var(--q3-neutral-default)]">Qs Type Breakup</h1>
          </div>

          {/* Redux-driven filter tabs */}
          {/* <TestFilterTabs /> */}
        </div>
      </div>

      {/* Content */}
      <div className="p-6 pt-2 space-y-8">
        <QsTypeBreakupSummary data={data} loading={loading} onResetFilters={onResetFilters} />
        <QsTypeBreakupTestwise data={data} loading={loading} onResetFilters={onResetFilters} />

        {/* Pagination */}
        {totalPages > 1 && (
          <PackPagination
            totalPages={totalPages}
            activePage={activePage}
            onPageClick={(page) => dispatch(setPage(page))}
          />
        )}
      </div>
    </div>
  );
};

export default QsTypeBreakup;
